import { appConfigKey } from "../../config/Config";

export const AgregarDivisa = (monto: string, codigoDivisa: Number) => {
    const tempMoneda = appConfigKey.keyIdentificadorDolares === codigoDivisa ? '$' : 'S/';
    return `${tempMoneda} ${monto}`;
};